import moment from "moment";
type Props = {
  created?: string;
  expiration?: string;
  active?: boolean;
  current?: { amount: number; currency_code: string; formatted: string };
  description?: string;
  spend?: { amount: string; currency_code: string; formatted: string };
};

export const checkTrialMessage = (currentTrial: Props = {}) => {
  const { expiration, active } = currentTrial;
  const remainingDays = moment(expiration).diff(moment(), "days");

  if (!active) return null;
  if (!expiration) return "free_trial";
  if (remainingDays > 2) {
    // if trial days is greater than 6 days remaining,
    // we assume the trial is still in progress
    return "free_trial";
  } else if (remainingDays <= 2 && remainingDays >= 0) {
    // if trial days is less than 2 days remaining but not before today
    return "trial_ending";
  } else {
    //The trial expiration day is before today
    //When the trial ends, the tag color changes to yellow and the text is 'Suspended'
    return "suspended";
  }
};
